module.exports = __webpack_public_path__ + "img/Jeremiah-Chiu---Zoom-Room-1-p-1080.88178b00.jpg";